<form [formGroup]="filtroForm">
	<div
		#buscardor
		class="buscador-banner grid divide-x grid-cols-7 grid-rows-1 items-center xl:gap-4 lg:gap-2 hs-collapse transition-all duration-300 bg-white rounded-full shadow-lg p-6 mx-auto max-w-[1250px] z-[3]"
		id="buscador-"
	>
		<h2 class="pb-0 mb-0 font-bold font-ubuntu xl:text-f18 lg:text-f15 text-[#000]">Compra tu pasaje:</h2>
		<div class="origen">
			<div style="padding: 0 0 0 20px">
				<p-iftalabel variant="on">
					<p-select
						inputId="in_label"
						[options]="localidadesOrigen"
						optionLabel="denominacion"
						styleClass="w-full"
						variant="filled"
						[filter]="true"
						[autofocusFilter]="false"
						filterBy="denominacion"
						placeholder="Seleccionar"
						(onChange)="onSelectLocalidad($event)"
						formControlName="origen"
					/>
					<label for="in_label">Origen:</label>
				</p-iftalabel>
			</div>
		</div>
		<div class="destino">
			<div style="padding: 0 0 0 20px">
				<p-iftalabel variant="on">
					<p-select
						id="seleccidie"
						inputId="in_label"
						[options]="localidadesDestino"
						[autofocusFilter]="false"
						optionLabel="denominacion"
						styleClass="w-full"
						variant="filled"
						[filter]="true"
						placeholder="Seleccionar"
						formControlName="destino"
						(onChange)="onSelectDestino($event)"
					/>
					<label for="in_label">Destino:</label>
				</p-iftalabel>
			</div>
		</div>
		<div class="f_salida">
			<div style="padding: 0 0 0 20px">
				<p-iftalabel variant="on">
					<p-datepicker
						formControlName="fechaSalida"
						(onSelect)="onSelectFechaIda($event)"
						dateFormat="dd/mm/yy"
						inputId="on_label"
						[readonlyInput]="true"
						[minDate]="today"
						showIcon
						iconDisplay="input"
						[placeholder]="'dd/mm/aaaa'"
						[showOtherMonths]="true"
						[selectOtherMonths]="true"
					/>
					<label for="in_label">Fecha salida:</label>
				</p-iftalabel>
			</div>
		</div>
		<div class="f_retorno">
			<div style="padding: 0 0 0 20px">
				<p-iftalabel variant="on">
					<p-datepicker
						formControlName="fechaRetorno"
						dateFormat="dd/mm/yy"
						inputId="in_label"
						[readonlyInput]="true"
						showIcon
						[minDate]="minFechaRetorno()"
						iconDisplay="input"
						[placeholder]="'dd/mm/aaaa'"
						[showOtherMonths]="true"
						[selectOtherMonths]="true"
					/>
					<label for="in_label">Fecha retorno:</label>
				</p-iftalabel>
			</div>
		</div>
		<div class="n_pasajeros">
			<div style="padding: 0 0 0 20px">
				<label class="absolute block font-ubuntu text-f13 text-black">N° pasajeros:</label>
				<app-passenger-selector (passengersChange)="onPassengersChange($event)" />
			</div>
		</div>
		<button
			type="button"
			(click)="onSubmit()"
			class="bg-[#EC6726] text-white py-2 px-6 hover:bg-[#4d4d4d] transition-all font-ubuntu text-f16 text-white-700 font-bold rounded-[20px] botton_form text-center"
		>
			BUSCAR
		</button>
	</div>
</form>
